/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { type Routes, RouterModule } from '@angular/router';
import { CoreModule, LazyloadService } from '@dm/core';
import { DMCommonModule } from 'app/common/dm-common.module';

import { VirtualMachineConsoleComponent } from './virtual-machine-console.component';

const routers: Routes = [{
    path: '',
    component: VirtualMachineConsoleComponent,
}];

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        DMCommonModule,
        RouterModule.forChild(routers),
    ],
    declarations: [VirtualMachineConsoleComponent],
    providers: [
        LazyloadService,
    ],
    exports: [VirtualMachineConsoleComponent],
})
export class VirtualMachineConsoleModule { }
